import axios from "axios"
// import router from '../routerManuaConfig'
import router from "../router/index"
import store from "../store"
import Vue from "vue"
import common from "../../util/common"

import applicationUserManager from "../Auth/applicationusermanager"
let base = '';
let ksaxBase = ''
let apiUrl = sessionStorage.getItem('publicPath');
if (apiUrl) {
  base = apiUrl;
} else {
  let baseUrl_product = "http://ksaxmall.openapi.ksaxshop.com" // ksax api 正式
  let baseUrl_dev = "http://ksaxmall.openapi.ksax.cn"          // ksax api 测试
  ksaxBase = process.env.NODE_ENV == "production" ? baseUrl_product : baseUrl_product
  base =
    // process.env.NODE_ENV == "production" ? "http://dev.erp.api.ksax.cn" : "" // 开发
    // process.env.NODE_ENV == "production" ? "http://erp.api.ksax.cn" : "" // erp测试
    // process.env.NODE_ENV == "production" ? "http://ksaxmall.openapi.ksax.cn" : "" // erp测试
    process.env.NODE_ENV == "production" ? "http://erp.api.ksaxshop.com" : "" // erp生产
  // process.env.NODE_ENV == "production" ? "http://192.168.0.79" : "" 
}
export const ksaxBaseUrl = ksaxBase
// 请求延时
axios.defaults.timeout = 5 * 60 * 1000
var storeTemp = store
axios.interceptors.request.use(
  (config) => {
    var curTime = new Date()
    var appKey = global.appKey
    var appSecret = global.appSecret
    var timeStamp = curTime.getTime() //时间戳
    var nonce = common.createRandomCode(10)
    var signature = common.sign(appKey, appSecret, timeStamp, nonce) //签名
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

    // 将租户Id放到请求头中
    //dataT["name"]="xxx"//添加name属性，值为xxx

    //config.headers.Abp["TenantId"] = storeTemp.state.tenantId;
    config.headers["Abp.TenantId"] = storeTemp.state.tenantId;
    config.headers["Abp-TenantId"] = storeTemp.state.tenantId;
    //config.headers.TenantId = storeTemp.state.tenantId
    if (
      storeTemp.state.token &&
      (curTime < expiretime && storeTemp.state.tokenExpire)
    ) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = "Bearer " + storeTemp.state.token
      config.headers.appKey = appKey
      config.headers.timeStamp = timeStamp
      config.headers.nonce = nonce
      config.headers.signature = signature
    }

    saveRefreshtime()

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 超时请求处理
    var originalRequest = error.config
    if (
      error.code == "ECONNABORTED" &&
      error.message.indexOf("timeout") != -1 &&
      !originalRequest._retry
    ) {
      Vue.prototype.$message({
        message: "请求超时！",
        type: "error",
      })

      originalRequest._retry = true
      return null
    }

    if (error.response) {
      console.log(error.response, 'error.response')
      if (error.response.status == 401) {
        var curTime = new Date()
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({
            token: window.localStorage.Token
          }).then(
            (res) => {
              if (res.success) {
                Vue.prototype.$message({
                  message: "refreshToken success! loading data...",
                  type: "success",
                })

                store.commit("saveToken", res.response.token)

                var curTime = new Date()
                var expiredate = new Date(
                  curTime.setSeconds(
                    curTime.getSeconds() + res.response.expires_in
                  )
                )
                store.commit("saveTokenExpire", expiredate)

                error.config.__isRetryRequest = true
                error.config.headers.Authorization =
                  "Bearer " + res.response.token
                return axios(error.config)
              } else {
                // 刷新token失败 清除token信息并跳转到登录页面
                ToLogin()
              }
            }
          )
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin()
        }
      }
      // 403 无权限
      if (error.response.status == 403) {
        Vue.prototype.$message({
          message: "失败！该操作无权限",
          type: "error",
        })
        return null
      }
      // 429 ip限流
      if (error.response.status == 429) {
        Vue.prototype.$message({
          message: "刷新次数过多，请稍事休息重试！",
          type: "error",
        })
        return null
      }
    }
    return error.response // 返回接口返回的错误信息
  }
)

export const BaseApiUrl = base
// 生成短链接
export const shortLink = (params) => {
  return axios.post(`http://s.ts03.com/bindurlfromexcl`, params)
}
// 登录
export const requestLogin = (params) => {
  return axios
    .get(`${base}/api/login/jwttoken3.0`, {
      params: params
    })
    .then((res) => res.data)
}
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data)
}

export const refreshToken = (params) => {
  return axios
    .get(`${base}/api/login/RefreshToken`, {
      params: params
    })
    .then((res) => res.data)
}

export const saveRefreshtime = (params) => {
  let nowtime = new Date()
  let lastRefreshtime = window.localStorage.refreshtime ?
    new Date(window.localStorage.refreshtime) :
    new Date(-1)
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

  let refreshCount = 1 //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount)
    window.localStorage.refreshtime = lastRefreshtime
  } else {
    window.localStorage.refreshtime = new Date(-1)
  }
}
const ToLogin = (params) => {
  store.commit("saveToken", "")
  store.commit("saveTokenExpire", "")
  store.commit("saveTagsData", "")
  store.commit("setIsSignIn", false)
  window.localStorage.removeItem("user")
  window.localStorage.removeItem("NavigationBar")

  if (global.IS_IDS4) {
    applicationUserManager.login()
  } else {
    router.replace({
      path: "/login",
      query: {
        redirect: router.currentRoute.fullPath
      },
    })

    window.location.reload()
  }
}

export const getUserByToken = (params) => {
  return axios
    .get(`${base}/api/user/getInfoByToken`, {
      params: params
    })
    .then((res) => res.data)
}
// 获取七牛token
export const getQiniuToken = (params) => {
  return axios.get(`${base}/api/Qiniu/GetToken`, { params: params })
}

// 租户
export const GetTenantId = (params) => {
  return axios.post(`${base}/api/services/app/Account/IsTenantAvailable`, params)
}
export const TenantRegister = (params) => {
  return axios.post(`${base}/api/services/app/Account/Register`, params)
}

// Token
export const Authenticate = (params) => {
  return axios.post(`${base}/api/TokenAuth/Authenticate`, params)
}
// 所有菜单
export const GetUserMenu = (params) => {
  return axios.get(`${base}/api/CurrentInfo/GetUserMenu`, { params: params })
}
// Menu
export const GetAllMenu = (params) => {
  return axios.get(`${base}/api/services/app/Menu/GetAll`, { params: params })
}
export const GetMenuTree = (params) => {
  return axios.get(`${base}/api/services/app/Menu/GetTree`, { params: params })
}
export const CreateMenu = (params) => {
  return axios.post(`${base}/api/services/app/Menu/Create`, params)
}
export const GetMenuDetail = (params) => {
  return axios.get(`${base}/api/services/app/Menu/Get`, { params: params })
}
export const UpdateMenu = (params) => {
  return axios.put(`${base}/api/services/app/Menu/Update`, params)
}
export const DeleteMenu = (params) => {
  return axios.delete(`${base}/api/services/app/Menu/Delete`, { params: params })
}
// Role
export const GetAllRole = (params) => {
  return axios.get(`${base}/api/services/app/Role/GetAll`, { params: params })
}
export const CreateRole = (params) => {
  return axios.post(`${base}/api/services/app/Role/Create`, params)
}
export const GetRoleDetail = (params) => {
  return axios.get(`${base}/api/services/app/Role/Get`, { params: params })
}
export const UpdateRole = (params) => {
  return axios.put(`${base}/api/services/app/Role/Update`, params)
}
export const DeleteRole = (params) => {
  return axios.delete(`${base}/api/services/app/Role/Delete`, { params: params })
}

export const GetPermissions = (params) => {
  return axios.get(`${base}/api/services/app/Role/GetPermissions`, { params: params })
}
export const SetPermissions = (params) => {
  return axios.post(`${base}/api/services/app/Role/SetPermissions`, params)
}

// User
export const GetAllUser = (params) => {
  return axios.get(`${base}/api/services/app/User/GetAll`, { params: params })
}
export const CreateUser = (params) => {
  return axios.post(`${base}/api/services/app/User/Create`, params)
}
export const GetUserDetail = (params) => {
  return axios.get(`${base}/api/services/app/User/Get`, { params: params })
}
export const UpdateUser = (params) => {
  return axios.put(`${base}/api/services/app/User/Update`, params)
}
export const DeleteUser = (params) => {
  return axios.delete(`${base}/api/services/app/User/Delete`, { params: params })
}
export const GetRoles = (params) => {
  return axios.get(`${base}/api/services/app/User/GetRoles`, { params: params })
}
export const ChangePassword = (params) => {
  return axios.post(`${base}/api/services/app/User/ChangePassword`, params)
}
// Tenant
export const GetAllTenant = (params) => {
  return axios.get(`${base}/api/services/app/Tenant/GetAll`, { params: params })
}
export const CreateTenant = (params) => {
  return axios.post(`${base}/api/services/app/Tenant/Create`, params)
}
export const GetTenantDetail = (params) => {
  return axios.get(`${base}/api/services/app/Tenant/Get`, { params: params })
}
export const UpdateTenant = (params) => {
  return axios.put(`${base}/api/services/app/Tenant/Update`, params)
}
export const DeleteTenant = (params) => {
  return axios.delete(`${base}/api/services/app/Tenant/Delete`, { params: params })
}

export const TenantGetPermissions = (params) => {
  return axios.get(`${base}/api/services/app/Tenant/GetPermissions`, { params: params })
}
export const TenantSetPermissions = (params) => {
  return axios.post(`${base}/api/services/app/Tenant/SetPermissions`, params)
}
export const ChangeTenantPsd = (params) => {
  return axios.post(`${base}/api/services/app/Tenant/ResetAdminPassword`, params)
}

// 仓库
export const GetAllWarehouse = (params) => {
  return axios.get(`${base}/api/services/app/Warehouse/GetAll`, { params: params })
}
export const CreateWarehouse = (params) => {
  return axios.post(`${base}/api/services/app/Warehouse/Create`, params)
}
export const GetWarehouseDetail = (params) => {
  return axios.get(`${base}/api/services/app/Warehouse/Get`, { params: params })
}
export const UpdateWarehouse = (params) => {
  return axios.put(`${base}/api/services/app/Warehouse/Update`, params)
}
export const DeleteWarehouse = (params) => {
  return axios.delete(`${base}/api/services/app/Warehouse/Delete`, { params: params })
}
export const UpdateDeliveryAreas = (params) => {
  return axios.put(`${base}/api/services/app/Warehouse/UpdateDeliveryAreas`, params)
}
export const AddInventoryItem = (params) => {
  return axios.post(`${base}/api/services/app/Inventory/AddInventoryItem`, params)
}
export const InventoryResetStock = (params) => {
  return axios.post(`${base}/api/services/app/Inventory/ResetStock`, params)
}


// 区域
export const CreateArea = (params) => {
  return axios.post(`${base}/api/services/app/Area/Create`, params)
}
export const GetAreaDetail = (params) => {
  return axios.get(`${base}/api/services/app/Area/Get`, { params: params })
}
export const UpdateArea = (params) => {
  return axios.put(`${base}/api/services/app/Area/Update`, params)
}
export const DeleteArea = (params) => {
  return axios.delete(`${base}/api/services/app/Area/Delete`, { params: params })
}
export const GetAllArea = (params) => {
  return axios.get(`${base}/api/services/app/Area/GetAll`, { params: params })
}
export const GetAreaTree = (params) => {
  return axios.get(`${base}/api/services/app/Area/GetTree`, { params: params })
}

// 库存
// export  const GetAllInventory = (params) =>{
//   return axios.get(`${base}/api/services/app/Inventory/GetAll`, {params: params})
// }
export const GetAllInventory = (params) => {
  return axios.post(`${base}/api/services/app/Inventory/GetAll`, params)
}
export const UploadInventory = (params) => {
  return axios.post(`${base}/api/services/app/Inventory/Upload`, params)
}
export const GetInventoryDetail = (params) => {
  return axios.get(`${base}/api/services/app/Inventory/Get`, { params: params })
}
export const UpdateInventory = (params) => {
  return axios.put(`${base}/api/services/app/Inventory/Upload`, params)
}
// 库存详情列表
export const GetAllInventoryItems = (params) => {
  return axios.get(`${base}/api/services/app/Inventory/GetAllInventoryItems`, { params: params })
}


// 品牌管理列表
export const brandGetAll = (params) => {
  return axios.get(`${base}/api/services/app/Brand/GetAll`, { params: params });
}
export const BrandCreate = (params) => {
  return axios.post(`${base}/api/services/app/Brand/Create`, params)
}
export const BrandDelete = (params) => {
  return axios.delete(`${base}/api/services/app/Brand/Delete`, { params: params })
}
export const BrandGet = (params) => {
  return axios.get(`${base}/api/services/app/Brand/Get`, { params: params })
}
export const BrandUpdate = (params) => {
  return axios.put(`${base}/api/services/app/Brand/Update`, params)
}
// 品类管理列表
export const CategoryGetAll = (params) => {
  return axios.get(`${base}/api/services/app/Category/GetAll`, { params: params })
}
export const CategoryCreate = (params) => {
  return axios.post(`${base}/api/services/app/Category/Create`, params)
}
export const CategoryDelete = (params) => {
  return axios.delete(`${base}/api/services/app/Category/Delete`, { params: params })
}
export const CategoryGet = (params) => {
  return axios.get(`${base}/api/services/app/Category/Get`, { params: params })
}
export const CategoryUpdate = (params) => {
  return axios.put(`${base}/api/services/app/Category/Update`, params)
}
export const CategoryGetTree = (params) => {
  return axios.get(`${base}/api/services/app/Category/GetTree`, { params: params })
}
// 属性模板
export const PropertyGroupCreate = (params) => {
  return axios.post(`${base}/api/services/app/PropertyGroup/Create`, params)
}
export const PropertyGroupDelete = (params) => {
  return axios.post(`${base}/api/services/app/PropertyGroup/Delete`, params)
}
export const PropertyGroupUpdate = (params) => {
  return axios.put(`${base}/api/services/app/PropertyGroup/Update`, params)
}
export const PropertyGroupGetAll = (params) => {
  return axios.get(`${base}/api/services/app/PropertyGroup/GetAll`, { params: params })
}
export const PropertyGroupGet = (params) => {
  return axios.get(`${base}/api/services/app/PropertyGroup/Get`, { params: params })
}
// 属性维护
export const PropertyValueCreate = (params) => {
  return axios.post(`${base}/api/services/app/PropertyValue/Create`, params)
}
export const PropertyValueDelete = (params) => {
  return axios.delete(`${base}/api/services/app/PropertyValue/Delete`, { params: params })
}
export const PropertyValueUpdate = (params) => {
  return axios.put(`${base}/api/services/app/PropertyValue/Update`, params)
}
export const PropertyValueGetAll = (params) => {
  return axios.get(`${base}/api/services/app/PropertyValue/GetAll`, { params: params })
}
export const PropertyValueGet = (params) => {
  return axios.get(`${base}/api/services/app/PropertyValue/Get`, { params: params })
}

export const PropertyCreate = (params) => {
  return axios.post(`${base}/api/services/app/Property/Create`, params)
}
export const PropertyDelete = (params) => {
  return axios.delete(`${base}/api/services/app/Property/Delete`, { params: params })
}
export const PropertyUpdate = (params) => {
  return axios.put(`${base}/api/services/app/Property/Update`, params)
}
export const PropertyGetAll = (params) => {
  return axios.get(`${base}/api/services/app/Property/GetAll`, { params: params })
}
export const PropertyGet = (params) => {
  return axios.get(`${base}/api/services/app/Property/Get`, { params: params })
}
export const GetAllWithItem = (params) => {
  return axios.get(`${base}/api/services/app/Property/GetAllWithItem`, { params: params })
}

export const DeleteProperties = (params) => {
  return axios.delete(`${base}/api/services/app/PropertyGroup/DeleteProperties`, { params: params })
}
export const UpdateProperties = (params) => {
  return axios.put(`${base}/api/services/app/PropertyGroup/UpdateProperties`, params)
}
export const GetAllProperties = (params) => {
  return axios.get(`${base}/api/services/app/PropertyGroup/GetAllProperties`, { params: params })
}
// SKU列表
export const GetProductSkuList = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/GetAllFullInfo`, { params: params })
}
export const GetProductSkuPreView = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/GetProductSkuPreView`, { params: params })
}
export const BatchCreateAndUpdate = (params) => {
  return axios.post(`${base}/api/services/app/ProductSku/BatchOperation`, params)
}
// 商品sku列表
export const ProductSkuGetAll = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/GetAll`, { params: params })
}
export const ProductSkuDelete = (params) => {
  return axios.post(`${base}/api/services/app/ProductSku/Delete`, params)
}
// spu列表
export const GetProductList = (params) => {
  return axios.get(`${base}/api/services/app/Product/GetAllList`, { params: params })
}
// 添加spu
export const ProductCreate = (params) => {
  return axios.post(`${base}/api/services/app/Product/Create`, params)
}
// 编辑spu
export const ProductUpdate = (params) => {
  return axios.put(`${base}/api/services/app/Product/Update`, params)
}
export const ProductDelete = (params) => {
  return axios.post(`${base}/api/services/app/Product/Delete`, params)
}
// spu详情
export const GetProducDetail = (params) => {
  return axios.get(`${base}/api/services/app/Product/Get`, { params: params })
}
// 商品图片添加
export const AddPicture = (params) => {
  return axios.post(`${base}/api/services/app/Product/AddPicture`, params)
}
// 商品图片删除
export const DeletePicture = (params) => {
  return axios.delete(`${base}/api/services/app/Product/DeletePicture`, { params: params })
}
// 商品图片修改
export const UpdatePicture = (params) => {
  return axios.put(`${base}/api/services/app/Product/UpdatePicture`, params)
}
// 分销商
export const GetAllReseller = (params) => {
  return axios.get(`${base}/api/services/app/Reseller/GetAll`, { params: params })
}
export const CreateReseller = (params) => {
  return axios.post(`${base}/api/services/app/Reseller/Create`, params)
}
export const GetResellerDetail = (params) => {
  return axios.get(`${base}/api/services/app/Reseller/Get`, { params: params })
}
export const UpdateReseller = (params) => {
  return axios.put(`${base}/api/services/app/Reseller/Update`, params)
}
export const DeleteReseller = (params) => {
  return axios.delete(`${base}/api/services/app/Reseller/Delete`, { params: params })
}

// 销售商品
export const SaleableCreate = (params) => {
  return axios.post(`${base}/api/services/app/SaleableProduct/Create`, params)
}
export const SaleableList = (params) => {
  return axios.get(`${base}/api/services/app/SaleableProduct/GetAll`, { params: params })
}
export const SaleableAddProduct = (params) => {
  return axios.post(`${base}/api/services/app/SaleableProduct/PushProduct`, params)
}

// 销售sku
export const SaleableSkuCreate = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/Create`, params)
}
export const SaleableSkuBatchCreate = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/BatchCreate`, params)
}
export const SaleableSkuUpdate = (params) => {
  return axios.put(`${base}/api/services/app/SaleableSku/Update`, params)
}
export const SaleableSkuBatchUpdate = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/BatchUpdate`, params)
}
export const SaleableSkuGetAll = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/GetAll`, params)
}
export const ProductSync = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/PushProduct`, params)
}

export const GetProductSkuByProductId = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/GetProductSkuByProductId`, { params: params })
}

// 系统分销商
export const CreateSysReseller = (params) => {
  return axios.post(`${base}/api/services/app/SysReseller/Create`, params)
}
export const UpdateSysReseller = (params) => {
  return axios.put(`${base}/api/services/app/SysReseller/Update`, params)
}
export const GetAllSysReseller = (params) => {
  return axios.get(`${base}/api/services/app/SysReseller/GetAll`, { params: params })
}
export const GetSysResellerDetail = (params) => {
  return axios.get(`${base}/api/services/app/SysReseller/Get`, { params: params })
}

// 获取发货区域
export const GetDeliveryAreas = (params) => {
  return axios.get(`${base}/api/services/app/Warehouse/GetDeliveryAreas`, { params: params })
}
// 获取仓库树
export const GetTreeWarehouse = (params) => {
  return axios.get(`${base}/api/services/app/Warehouse/GetTree`, { params: params })
}
// 绑定系统分销商
export const BindSysReseller = (params) => {
  return axios.post(`${base}/api/services/app/Reseller/BindSysReseller`, params)
}

// 供应商
export const GetAllSupplier = (params) => {
  return axios.get(`${base}/api/services/app/Supplier/GetAll`, { params: params })
}
export const CreateSupplier = (params) => {
  return axios.post(`${base}/api/services/app/Supplier/Create`, params)
}

/*****************************************代采购订单***************************************************/

// /api/services/app/OrderPurchase/BatchCreate  提价采购、批量提交采购
export const BatchCreate1 = (params) => {
  return axios.post(`${base}/api/services/app/OrderPurchase/BatchCreate`, params)
}
// /api/services/app/OrderPurchase/GetAll  代采购列表
export const OrderPurchaseGetAll = (params) => {
  return axios.get(`${base}/api/services/app/Order/GetAll`, { params: params })
}
// /api/services/app/Order/Get  代采购详情
export const OrderPurchaseGet = (params) => {
  return axios.get(`${base}/api/services/app/Order/Get`, { params: params })
}
// /api/services/app/OrderLogistic/Get  代采购订单详情查看物流
export const OrderLogisticGet = (params) => {
  return axios.get(`${base}/api/services/app/OrderLogistic/Get`, { params: params })
}
// /api/services/app/OrderLogistic/Update  代采购订单详情更改
export const OrderLogisticUpdate = (params) => {
  return axios.get(`${base}/api/services/app/OrderLogistic/get`, { params: params })
}
// 添加物流信息
export const OrderLogisticEdit = (params) => {
  return axios.put(`${base}/api/services/app/OrderLogistic/Update`, params)
}

// /api/services/app/Supplier/GetAll  获取所有供货商
export const SupplierGetAll = (params) => {
  return axios.get(`${base}/api/services/app/Supplier/GetAll`, { params: params });
}

/*****************************************订单详情***************************************************/
// services/app/LogisticsCompanyService/GetAll  获取所有物流公司list
export const LogisticsCompanyServiceGetAll = (params) => {
  return axios.get(`${base}/api/services/app/LogisticsCompanyService/GetAll`, { params: params })
}

/*****************************************待发货***************************************************/
// /api/services/app/OrderPurchase/GetAll  代发货列表---状态为待发货  共用
// /api/services/app/OrderLogistic/Get  发货详情查询-----共用
// /api/services/app/OrderLogistic/CreateAndPush  订单发货 物流新增
export const BatchCreate = (params) => {
  return axios.post(`${base}/api/services/app/OrderLogistic/CreateAndPush`, params)
}
// export  const OrderLogisticGet = (params) =>{
//   return axios.get(`${base}/api/services/app/OrderLogistic/Get`, {params: params})
// }
// 导出？？
// 导入物流信息？？
/*****************************************待收货***************************************************/
// 导出
/*****************************************已收货***************************************************/
// 导出
// 导入物流信息

// /api/services/app/SaleableSku/GetKSAXSupplierUsers  用户列表
export const GetKSAXSupplierUsers = (params) => {
  return axios.get(`${base}/api/services/app/SaleableSku/GetKSAXSupplierUsers`, { params: params })
}
// export  const OrderAfterSaleGetAll = (params) =>{
//   return axios.get(`${base}/api/services/app/OrderAfterSale/GetAll`, {params: params})
// }
// export  const OrderAfterSaleConfirm = (params) =>{
//   return axios.post(`${base}/api/services/app/OrderAfterSale/Confirm`, params)
// }
// export  const OrderAfterSaleReject = (params) =>{
//   return axios.post(`${base}/api/services/app/OrderAfterSale/Reject`, params)
// }
// export  const OrderAfterSaleGet = (params) =>{
//   return axios.get(`${base}/api/services/app/OrderAfterSale/Get`, {params: params})
// }


// /api/services/app/SaleableSku/GetSaleableAreas
export const GetSaleableAreas = (params) => {
  return axios.get(`${base}/api/services/app/SaleableSku/GetSaleableAreas`, { params: params })
}

// /api/services/app/Area/GetAll  获取区域信息
export const AreaGetAll = (params) => {
  return axios.get(`${base}/api/services/app/Area/GetAll`, { params: params });
}
export const UpdateSaleableAreas = (params) => {
  return axios.put(`${base}/api/services/app/SaleableSku/UpdateSaleableAreas`, params)
}

// /api/services/app/Supplier/SetAutoPurchaseState 设置自动采购
export const SetAutoPurchaseState = (params) => {
  return axios.post(`${base}/api/services/app/Supplier/SetAutoPurchaseState`, params)
}

// /api/services/app/Supplier/Update 供应商更新
export const SupplierUpdate = (params) => {
  return axios.put(`${base}/api/services/app/Supplier/Update`, params)
}
export const UpdateDefaultStock = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/UpdateDefaultStock`, params)
}
export const ProductSkuExport = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/Export`, { params: params, responseType: "blob" })
}
export const OrderExport = (params) => {
  return axios.get(`${base}/api/services/app/Order/Export`, { params: params, responseType: "blob" })
}
export const OrderLogisticUpload = (params) => {
  return axios.post(`${base}/api/services/app/OrderLogistic/Upload`, params)
}
export const OrderAfterSaleGetAll = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/GetAll`, { params: params })
}
export const OrderAfterSaleConfirm = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/Confirm`, params)
}
// 售后审核驳回
export const OrderAfterSaleReject = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/Reject`, params)
}
// 详情
export const OrderAfterSaleGet = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/Get`, { params: params })
}
// 售后审核---退款
// /api/services/app/OrderAfterSale/Update
export const OrderAfterSaleUpdate = (params) => {
  return axios.put(`${base}/api/services/app/OrderAfterSale/Update`, params)
}

// /api/services/app/OrderAfterSaleDetail/ConfirmReturn  退换货订单确认退回
export const ConfirmReturn = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSaleDetail/ConfirmReturn`, params)
}

// /api/services/app/Inventory/GetAllInventoryItemsWithOrder
export const GetAllInventoryItemsWithOrder = (params) => {
  return axios.get(`${base}/api/services/app/Inventory/GetAllInventoryItemsWithOrder`, { params: params })
}


// /api/services/app/OrderAfterSaleLogistic/GetAll  物流信息  更新物流  仓库查询
export const OrderAfterSaleLogisticGetAll = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSaleLogistic/GetAll`, { params: params })
}

//物流查询
export const OrderAfterSaleLogisticGet = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSaleLogistic/Get`, { params: params })
}

// 更新物流
export const OrderAfterSaleLogisticCreate = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSaleLogistic/Create`, params)
}

// 删除物流
export const OrderAfterSaleLogisticDelete = (params) => {
  return axios.delete(`${base}/api/services/app/OrderAfterSaleLogistic/Delete`, { params: params })
}
// 更新物流信息
export const OrderAfterSaleLogisticUpdate = (params) => {
  return axios.put(`${base}/api/services/app/OrderAfterSaleLogistic/Update`, params)
}

// /api/services/app/OrderAfterSaleWarehouse/GetAll  //// 更新物流 仓库查询
export const OrderAfterSaleWarehouseGetAll = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSaleWarehouse/GetAll`, { params: params })
}

// /api/services/app/OrderAfterSaleWarehouse/Create  换货详情--发货
export const OrderAfterSaleWarehouseCreate = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSaleWarehouse/Create`, params)
}

// /api/services/app/OrderWarehouse/Create  订单发货
export const OrderWarehouseCreate = (params) => {
  return axios.post(`${base}/api/services/app/OrderWarehouse/Create`, params)
}

// /api/services/app/OrderWarehouse/GetAll  订单发货  物流更新列表
export const OrderWarehouseGetAll = (params) => {
  return axios.get(`${base}/api/services/app/OrderWarehouse/GetAll`, { params: params })
}

// 获取商品：/api/services/app/Product/GetJDCtpProduct
export const GetJDCtpProduct = (params) => {
  return axios.post(`${base}/api/services/app/Product/GetJDCtpProduct`, params)
}
export const JDPopProductQuery = (params) => {
  return axios.post(`${base}/api/services/app/Product/JDPopProductQuery`, params)
}
// 京东品牌列表：/api/services/app/JdBrand/GetAll
// /api/services/app/PlatformBrand/GetAll
export const JdBrandGetAll = (params) => {
  return axios.get(`${base}/api/services/app/PlatformBrand/GetAll`, { params: params })
}
// 京东分类列表：/api/services/app/JdType/GetAll
// /api/services/app/PlatformType/GetAll
export const JdTypeGetAll = (params) => {
  return axios.get(`${base}/api/services/app/PlatformType/GetAll`, { params: params })
}
// 操作记录：/api/services/app/ProductPlatformSyncRecord/GetAll
export const ProductPlatformSyncRecordGetAll = (params) => {
  return axios.get(`${base}/api/services/app/ProductPlatformSyncRecord/GetAll`, { params: params })
}

// /api/services/app/Product/UploadJDCtp  导入京东开普勒商品
export const ProductUploadJDCtp = (params) => {
  return axios.post(`${base}/api/services/app/Product/UploadJDCtp`, params)
}
// 权限模板
// /api/services/app/TenantPermissionTemplate/Get  详情
export const TenantPermissionTemplateGet = (params) => {
  return axios.get(`${base}/api/services/app/TenantPermissionTemplate/Get`, { params: params })
}
// /api/services/app/TenantPermissionTemplate/GetAll  列表
export const TenantPermissionTemplateGetAll = (params) => {
  return axios.get(`${base}/api/services/app/TenantPermissionTemplate/GetAll`, { params: params })
}
// /api/services/app/TenantPermissionTemplate/Update 更新
export const TenantPermissionTemplateUpdate = (params) => {
  return axios.put(`${base}/api/services/app/TenantPermissionTemplate/Update`, params)
}
// /api/services/app/TenantPermissionTemplate/Delete 删除
export const TenantPermissionTemplateDelete = (params) => {
  return axios.delete(`${base}/api/services/app/TenantPermissionTemplate/Delete`, { params: params })
}
// /api/services/app/TenantPermissionTemplate/Create 创建
export const TenantPermissionTemplateCreate = (params) => {
  return axios.post(`${base}/api/services/app/TenantPermissionTemplate/Create`, params)
}

// /api/services/app/Tenant/UpdatePermissionsFromTemplate
export const UpdatePermissionsFromTemplate = (params) => {
  return axios.put(`${base}/api/services/app/Tenant/UpdatePermissionsFromTemplate`, params)
}
// 系统供应商
// /api/services/app/SysSupplier/Create  创建  post
export const SysSupplierCreate = (params) => {
  return axios.post(`${base}/api/services/app/SysSupplier/Create`, params)
}
// /api/services/app/SysSupplier/Update   修改  put
export const SysSupplierUpdate = (params) => {
  return axios.put(`${base}/api/services/app/SysSupplier/Update`, params)
}
// /api/services/app/SysSupplier/GetAll   全部   get
export const SysSupplierGetAll = (params) => {
  return axios.get(`${base}/api/services/app/SysSupplier/GetAll`, { params: params })
}
// /api/services/app/SysSupplier/Get    详情   get
export const SysSupplierGet = (params) => {
  return axios.get(`${base}/api/services/app/SysSupplier/Get`, { params: params })
}


// /api/services/app/Supplier/BindSysSupplier  绑定系统经销商
export const BindSysSupplier = (params) => {
  return axios.post(`${base}/api/services/app/Supplier/BindSysSupplier`, params)
}

// /api/services/app/ProductSku/GetProductSkuForSaleable
export const GetProductSkuForSaleable = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/GetProductSkuForSaleable`, { params: params })
}
// 财务--分销商
// /api/services/app/Reseller/GetVerifyAll  分销商对账列表
export const GetVerifyAll = (params) => {
  return axios.get(`${base}/api/services/app/Reseller/GetVerifyAll`, { params: params })
}

// 分销商订单列表/api/services/app/Reseller/GetResellerOrderList
export const GetResellerOrderList = (params) => {
  console.log('params-----', params)
  return axios.get(`${base}/api/services/app/Reseller/GetResellerOrderList`, { params: params })
}

// 供货商对账
// 列表 /api/services/app/Supplier/GetVerifyAll
export const SupplierGetVerifyAll = (params) => {
  return axios.get(`${base}/api/services/app/Supplier/GetVerifyAll`, { params: params })
}
// 分销商对账/api/services/app/Reseller/ResellerVerify
export const ResellerVerify = (params) => {
  return axios.post(`${base}/api/services/app/Reseller/ResellerVerify`, params)
}

// 供货商对账/api/services/app/Supplier/SupplierVerify
export const SupplierSupplierVerify = (params) => {
  return axios.post(`${base}/api/services/app/Supplier/SupplierVerify`, params)
}

// 订单列表/api/services/app/Supplier/GetSupplierOrderList
export const GetSupplierOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Supplier/GetSupplierOrderList`, { params: params })
}

// 售后单处理  /api/services/app/OrderAfterSale/FinanceHandle 待处理 Pending = 0,确认Confirm = 1,拒绝Refuse = 2
export const FinanceHandle = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/FinanceHandle`, params)
}

// 开票管理
// 开票分销商列表
// /api/services/app/Reseller/GetBillingAll
export const GetBillingAll = (params) => {
  return axios.get(`${base}/api/services/app/Reseller/GetBillingAll`, { params: params })
}

// 开票订单列表 /api/services/app/Reseller/GetBillingOrderList
export const GetBillingOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Reseller/GetBillingOrderList`, { params: params })
}
// 获取开票详情订单    /api​/services​/app​/Reseller​/GetBillingOrderList
// /api/services/app/FinanceBilling/GetBillingOrders
export const GetBillingOrders = (params) => {
  return axios.get(`${base}/api/services/app/FinanceBilling/GetBillingOrders`, { params: params })
}
// 获取开票列表   /api/services/app/FinanceBilling/GetAll
export const FinanceBillingGetAll = (params) => {
  return axios.get(`${base}/api/services/app/FinanceBilling/GetAll`, { params: params })
}

// 添加开票信息
// /api/services/app/FinanceBilling/Create
export const FinanceBillingCreate = (params) => {
  return axios.post(`${base}/api/services/app/FinanceBilling/Create`, params)
}

// /api/services/app/Reseller/ExportResellerOrder 分销商对账导出
export const ExportResellerOrder = (params) => {
  return axios.get(`${base}/api/services/app/Reseller/ExportResellerOrder`, { params: params, responseType: "blob" })
}

// /api/services/app/Supplier/ExportSupplierOrder 分销商对账导出
export const ExportSupplierOrder = (params) => {
  return axios.get(`${base}/api/services/app/Supplier/ExportSupplierOrder`, { params: params, responseType: "blob" })
}

// /api/services/app/OrderAfterSale/Export 分退款订单导出
export const OrderAfterSaleExport = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/Export`, { params: params, responseType: "blob" })
}
// 开票记录详情导出
export const FinanceBillingExport = (params) => {
  return axios.get(`${base}/api/services/app/FinanceBilling/Export`, { params: params, responseType: "blob" })
}

// /api/services/app/Order/JdCtpOrder开普勒下单
export const JdCtpOrder = (params) => {
  return axios.post(`${base}/api/services/app/Order/JdCtpOrder`, params)
}

// /api/services/app/OrderAfterSale/JDCtpGetIsCanApplyInfo  是否可以发起售后   post
export const JDCtpGetIsCanApplyInfo = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/JDCtpGetIsCanApplyInfo`, params)
}
// /api/services/app/OrderAfterSale/JDCtpCreateAfsApply  发起京东售后   post
export const JDCtpCreateAfsApply = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/JDCtpCreateAfsApply`, params)
}

// /api/services/app/OrderAfterSale/JDCtpGetApplyReason   查询售后原因   post
export const JDCtpGetApplyReason = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/JDCtpGetApplyReason`, params)
}
// /api/services/app/OrderAfterSale/JDCtpCancelOrder   取消订单  post
export const JDCtpCancelOrder = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/JDCtpCancelOrder`, params)
}
// 获取租户详情
export const TenantGetTenantDetail = (params) => {
  return axios.get(`${base}/api/services/app/Tenant/Get`, { params: params })
}
// /api/services/app/Supplier/SetPriceProportion
// 供应商点位设置
export const SetPriceProportion = (params) => {
  return axios.post(`${base}/api/services/app/Supplier/SetPriceProportion`, params)
}


export const BatchUpdateUseWarehouseInventory = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/BatchUpdateUseWarehouseInventory`, params)
}

export const AutoJdCtpOrder = (params) => {
  return axios.post(`${base}/api/services/app/Order/AutoJdCtpOrder`, params)
}

export const PushPrice = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/PushPrice`, params)
}

export const BatchUpdatePrice = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/BatchUpdatePrice`, params)
}

export const GetAllByWarehouse = (params) => {
  return axios.get(`${base}/api/services/app/WarehouseCode/GetAllByWarehouse`, { params: params })
}
export const WarehouseCodeBatchCreate = (params) => {
  return axios.post(`${base}/api/services/app/WarehouseCode/BatchCreate`, params)
}
export const WarehouseCodeUpdate = (params) => {
  return axios.put(`${base}/api/services/app/WarehouseCode/Update`, params)
}
export const WarehouseCodeDelete = (params) => {
  return axios.delete(`${base}/api/services/app/WarehouseCode/Delete`, { params: params })
}

// 资金账户   提现审核 通过
export const OpenWithdrawalOrderApprove = (params) => {
  return axios.post(`${base}/api/services/app/OpenWithdrawalOrder/Approve`, params)
}
// 资金账户   提现审核 拒绝
export const OpenWithdrawalOrderRefuse = (params) => {
  return axios.post(`${base}/api/services/app/OpenWithdrawalOrder/Refuse`, params)
}

// 资金账户  申请提现
export const ApplyWithdrawal = (params) => {
  return axios.post(`${base}/api/services/app/CapitalAccount/ApplyWithdrawal`, params)
}

// 资金账户   详情
export const CapitalAccountGet = (params) => {
  return axios.get(`${base}/api/services/app/CapitalAccount/Get`, { params: params })
}
// 资金账户   查询冻结金额明细
export const GetFrozenRecordList = (params) => {
  return axios.get(`${base}/api/services/app/CapitalAccount/GetFrozenRecordList`, { params: params })
}
// 资金账户   查询可用余额
export const GetBalanceRecordList = (params) => {
  return axios.get(`${base}/api/services/app/CapitalAccount/GetBalanceRecordList`, { params: params })
}

// 资金账户    提现审核明细
export const WithdrawalOrderGetList = (params) => {
  return axios.get(`${base}/api/services/app/WithdrawalOrder/GetList`, { params: params })
}
// 2023/1/5 熊伟添加
// 商品上下架
export const ProductSkuShelves = (params) => {
  return axios.post(`${base}/api/services/app/ProductSku/Shelves`, params)
}
// 新商品sku列表
export const ProductSkuGetAllNew = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/GetAllIncludingPrice`, { params: params })
}
export const GetKSAXCommodityLibrary = (params) => {
  return axios.get(`${base}/api/services/app/Product/GetKSAXCommodityLibrary`, { params: params })
}
// 型号查询  KFP-35GW/BDN8Y  测试code
export const GetSimpleList = (params) => {
  return axios.get(`${base}/api/services/app/Product/GetSimpleList`, { params: params })
}
// 根据型号    获取商品
export const Product_SpuModelGetDetail = (params) => {
  return axios.get(`${base}/api/services/app/Product/GetDetail`, { params: params })
}
// 查询模板详情   GET
// Product_SpuModel/GetDetail
// 参数： id
// 根据key模糊匹配查询模板列表  GET
// Product_SpuModel/GetSimpleList
// 参数： modelCode

// 查询物流
export const GetOrderLogistics = (params) => {
  return axios.get(`${base}/api/services/app/Order/GetOrderLogistics`, { params: params })
}
export const GetOrderLogisticsKSAX = (params) => {
  return axios.get(`${base}/api/services/app/Order/GetOrderLogisticsKSAX`, { params: params })
}
// /api/services/app/Order/CMBPayList
export const OrderCMBPayList = (params) => {
  return axios.get(`${base}/api/services/app/Order/CMBPayList`, { params: params })
}
export const AddSupplierSettled = (params) => {
  return axios.post(`${base}/api/services/app/Public/AddSupplierSettled`, params)
}
export const ViewProgress = (params) => {
  return axios.post(`${base}/api/services/app/Public/ViewProgress`, params)
}
export const MobileVerifyCode = (params) => {
  return axios.post(`${base}/api/services/app/Public/MobileVerifyCode`, params)
}
// 公众号二维码
export const WeChatGetQrCodeUrl = (params) => {
  return axios.get(`${base}/api/WeChat/GetQrCodeUrl`, { params: params })
}
// 新增sku模板接口
export const PropertyGroupTree = (params) => {
  return axios.get(`${base}/api/services/app/PropertyGroup/GetTree`, { params: params })
}
// 编辑sku模板接口
export const ProductGetTree = (params) => {
  return axios.get(`${base}/api/services/app/Product/GetTree`, { params: params })
}
export const ProductSkuCreateMany = (params) => {
  return axios.post(`${base}/api/services/app/ProductSku/CreateMany`, params)
}
export const ProductSkuGetMany = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/GetMany`, { params: params })
}
export const SaleableSkuGetMany = (params) => {
  return axios.get(`${base}/api/services/app/SaleableSku/GetMany`, { params: params })
}
export const CreateOrUpdateMany = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/CreateOrUpdateMany`, params)
}
// 区域限购模板
export const RestrictionAreaGroupCreate = (params) => {
  return axios.post(`${base}/api/services/app/RestrictionAreaGroup/Create`, params)
}
export const RestrictionAreaGroupUpdate = (params) => {
  return axios.put(`${base}/api/services/app/RestrictionAreaGroup/Update`, params)
}
export const RestrictionAreaGroupDelete = (params) => {
  return axios.delete(`${base}/api/services/app/RestrictionAreaGroup/Delete`, { params: params })
}
export const RestrictionAreaGroupGet = (params) => {
  return axios.get(`${base}/api/services/app/RestrictionAreaGroup/Get`, { params: params })
}
export const RestrictionAreaGroupGetAll = (params) => {
  return axios.get(`${base}/api/services/app/RestrictionAreaGroup/GetAll`, { params: params })
}
export const ProductSkuGetManyList = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/GetManyList`, { params: params })
}
export const UpdateShelvesMany = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/UpdateShelvesMany`, params)
}
export const ExportManyList = (params) => {
  return axios.get(`${base}/api/services/app/ProductSku/ExportManyList`, { params: params, responseType: "blob" })
}
export const CreateAndPushMany = (params) => {
  return axios.post(`${base}/api/services/app/OrderLogistic/CreateAndPushMany`, params)
}
export const GetLogisticsMany = (params) => {
  return axios.get(`${base}/api/services/app/Order/GetLogisticsMany`, { params: params })
}
export const DeleteAndPushMany = (params) => {
  return axios.delete(`${base}/api/services/app/OrderLogistic/DeleteAndPushMany`, { params: params })
}
export const DeleteAndPushItem = (params) => {
  return axios.delete(`${base}/api/services/app/OrderLogistic/DeleteAndPushItem`, { params: params })
}
export const OrderGetAllMany = (params) => {
  return axios.get(`${base}/api/services/app/Order/GetAllMany`, { params: params })
}
export const GetCountMany = (params) => {
  return axios.get(`${base}/api/services/app/Order/GetCountMany`, { params: params })
}
export const ImportMany = (params) => {
  return axios.post(`${base}/api/services/app/OrderLogistic/ImportMany`, params)
}
export const ExportMany = (params) => {
  return axios.get(`${base}/api/services/app/Order/ExportMany`, { params: params, responseType: "blob" })
}
export const AfterSaleListForERP = (params) => {
  return axios.get(`${base}/api/services/app/Order/AfterSaleListForERP`, { params: params })
}
export const GetHandyUpdateList = (params) => {
  return axios.get(`${base}/api/services/app/SaleableSku/GetHandyUpdateList`, { params: params })
}
export const ExcuteHandyUpdate = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/ExcuteHandyUpdate`, params)
}
export const GetLogisticsByNumber = (params) => {
  return axios.get(`${base}/api/services/app/Order/GetLogisticsByNumber`, { params: params })
}
// 快分销列表
// /api/services/app/Distribution/DistributionList
export const DistributionList = (params) => {
  return axios.post(`${base}/api/services/app/Distribution/DistributionList`, params)
}
// 设置分销价
// /api/services/app/Distribution/DistributionSetPrice
export const DistributionSetPrice = (params) => {
  return axios.post(`${base}/api/services/app/Distribution/DistributionSetPrice`, params)
}
// 快分销移除
// /api/services/app/Distribution/DistributionRemove
export const DistributionRemove = (params) => {
  return axios.post(`${base}/api/services/app/Distribution/DistributionRemove`, params)
}
// 自有商品库导入列表
// /api/services/app/Distribution/GetErpProductList
export const GetErpProductList = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/GetErpProductList`, { params: params })
}
// 营客通商品导入列表
// /api/services/app/Distribution/DistributionImportList
export const DistributionImportList = (params) => {
  return axios.post(`${base}/api/services/app/Distribution/DistributionImportList`, params)
}
// 自有/营客通商品导入
// /api/services/app/Distribution/DistributionImport
export const DistributionImport = (params) => {
  return axios.post(`${base}/api/services/app/Distribution/DistributionImport`, params)
}

//  分销   订单   列表
export const DistributionOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/DistributionOrderList`, { params: params })
}
// 分销  待付款    订单列表
export const DistributionUnPaidOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/DistributionUnPaidOrderList`, { params: params })
}
// 分销   已付款   订单列表
export const DistributionHasPaidOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/DistributionHasPaidOrderList`, { params: params })
}
// 分销   订单付款   信息
export const DistributionPayInfo = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/DistributionPayInfo`, { params: params })
}

// 分销    订单支付
export const DistributionPay = (params) => {
  return axios.post(`${base}/api/services/app/Distribution/DistributionPay`, params)
}

// 分销   订单批量付款   信息
export const DistributionBatchPayInfo = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/DistributionBatchPayInfo`, { params: params })
}

// 分销    批量订单支付
export const DistributionBatchPay = (params) => {
  return axios.post(`${base}/api/services/app/Distribution/DistributionBatchPay`, params)
}

// 分销订单导出
export const ExportDistributionOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/ExportDistributionOrderList`, { params: params, responseType: "blob" })
}
// 分销待付款订单列表导出
export const ExportDistributionUnPaidOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/ExportDistributionUnPaidOrderList`, { params: params, responseType: "blob" })
}
// 订单已付款列表导出
export const ExportDistributionHasPaidOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Distribution/ExportDistributionHasPaidOrderList`, { params: params, responseType: "blob" })
}

// 导出分销Sku列表

export const ExportDistributionList = (params) => {
  return axios.post(`${base}/api/services/app/Distribution/ExportDistributionList`, params, { responseType: "blob" })
}

//  申诉列表
export const OrderAfterSaleAppealList = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/AppealList`, { params: params })
}
//  申诉详情
export const OrderAfterSaleErpDetail = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/ErpDetail`, { params: params })
}
// /api/services/app/OrderAfterSale/AuditAppeal 申诉审核
export const OrderAfterSaleAuditAppeal = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/AuditAppeal`, params)
}
// 申诉记录
export const OrderAfterSaleAppealRecord = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/AppealRecord`, { params: params })
}
// 售后单列表
export const OrderAfterSaleErpList = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/ErpList`, { params: params })
}
export const purListV3 = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/ListV3`, { params: params })
}
export const GetAfterSaleOrderSupList = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/GetAfterSaleOrderSupList`, { params: params })
}
// 拒绝
export const AfterSaleOrderAuditRefuse = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/BusinessRefuse`, params)
}

// 通过
export const AfterSaleOrderAuditPass = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/BusinessAdopt`, params)
}
// ERP售后单列表总数
export const OrderAfterSaleErpListCount = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/ErpListCount`, { params: params })
}

// 添加订单备注
export const OrderCreateOrderNote = (params) => {
  return axios.post(`${base}/api/services/app/Order/CreateOrderNote`, params)
}

// 备注列表
export const OrderGetOrderNoteList = (params) => {
  return axios.get(`${base}/api/services/app/Order/GetOrderNoteList`, { params: params })
}
// 批量导入修改
export const SaleableSkuUploadSaleableSku = (params) => {
  return axios.post(`${base}/api/services/app/SaleableSku/UploadSaleableSku`, params)
}
// 售后添加备注
// /api/services/app/OrderAfterSale/AddAfterSaleOrderNote
export const AddAfterSaleOrderNote = (params) => {
  return axios.post(`${base}/api/services/app/OrderAfterSale/AddAfterSaleOrderNote`, params)
}
// 售后订单备注列表
// /api/services/app/OrderAfterSale/GetAfterSaleOrderNoteList
export const GetAfterSaleOrderNoteList = (params) => {
  return axios.get(`${base}/api/services/app/OrderAfterSale/GetAfterSaleOrderNoteList`, { params: params })
}
export const ErpUnSentProductList = (params) => {
  return axios.get(`${base}/api/services/app/Product/ErpUnSentProductList`, { params: params })
}
export const ErpUnSentProductImport = (params) => {
  return axios.post(`${base}/api/services/app/Product/ErpUnSentProductImport`, params)
}
export const SysSettlementOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Order/SysSettlementOrderList`, { params: params })
}
export const KSAXWalletAccountDetail = (params) => {
  return axios.get(`${base}/api/services/app/KSAX/WalletAccountDetail`, { params: params })
}
export const KSAXSuppliersDetail = (params) => {
  return axios.get(`${base}/api/services/app/KSAX/SuppliersDetail`, { params: params })
}
export const KSAXWalletRecordList = (params) => {
  return axios.get(`${base}/api/services/app/KSAX/WalletRecordList`, { params: params })
}
export const KSAXUpdatePassword = (params) => {
  return axios.post(`${base}/api/services/app/KSAX/UpdatePassword`, params)
}
export const KSAXWithdrawalApplication = (params) => {
  return axios.post(`${base}/api/services/app/KSAX/WithdrawalApplication?resellerId=${params.supId}`, params)
}
export const KSAXRechargeApplication = (params) => {
  return axios.post(`${base}/api/services/app/KSAX/RechargeApplication?resellerId=${params.supId}`, params)
}
export const SysSettlementOrderTotal = (params) => {
  return axios.get(`${base}/api/services/app/Order/SysSettlementOrderTotal`, { params: params })
}
export const ExportSysSettlementOrderList = (params) => {
  return axios.get(`${base}/api/services/app/Order/ExportSysSettlementOrderList`, { params: params, responseType: "blob" })
}
export const ExportWalletRecordList = (params) => {
  return axios.get(`${base}/api/services/app/KSAX/ExportWalletRecordList`, { params: params, responseType: "blob" })
}
export const Recepted = (params) => {
  return axios.post(`${base}/api/services/app/Order/Recepted`, params)
}
export const CheckProhibited = (params) => {
  return axios.get(`${base}/api/services/app/Product/CheckProhibited`, { params: params })
}
export const GetProhibitedList = (params) => {
  return axios.get(`${base}/api/services/app/Product/GetProhibitedList`, { params: params })
}
export const KSAXApiRequest = (params) => {
  return axios.post(`${base}/api/services/app/KSAX/KSAXApiRequest`, params)
}
export const KSAXApiUpload = (params) => {
  return axios.post(`${base}/api/services/app/KSAX/KSAXApiUpload`, params)
}
export const BusinessGetLogisticsByNumber = (params) => {
  return axios.get(`${base}/api/Business_UserManager/GetLogisticsByNumber`, { params: params })
}
export const ExportByList = (params) => {
  return axios.get(`${base}/api/ChildOrder/ExportByList`, { params: params })
}
export const UpdateInRoomNotice = (params) => {
  return axios.post(`${base}/api/Suppliers/UpdateInRoomNotice`, params)
}
export const GetContractCodeByAccount = (params) => {
  return axios.get(`${base}/api/services/app/Account/GetContractCodeByAccount`, { params: params })
}

export const MyWorkOrderPage = (params) => {
  return axios.get(`${base}/api/ERPWorkOrder/MyWorkOrderPage`, { params: params })
}
export const GetMyWorkOrderOverview = (params) => {
  return axios.get(`${base}/api/ERPWorkOrder/GetOverview`, { params: params })
}
export const WorkOrderTakeOrders = (params) => {
  return axios.post(`${base}/api/ERPWorkOrder/TakeOrders`, params)
}
export const GetMyWorkOrderDetail = (params) => {
  return axios.get(`${base}/api/ERPWorkOrder/Detail`, { params: params })
}
export const WorkOrderFollowUp = (params) => {
  return axios.post(`${base}/api/ERPWorkOrder/FollowUp`, params)
}